<app-modal-mensagem
  *ngIf="sucesso"
  tipo="sucesso"
  titulo="Sucesso!"
  mensagem="Obra perdida registrada com sucesso!"
  textoConfirmar="Continuar"
  (confirmar)="continuar()"
></app-modal-mensagem>

<div class="modal-panel-tarefa" *ngIf="!sucesso">
  <div class="modal-header">
    <div class="modal-header-left">
      <div class="modal-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10" />
          <line x1="15" y1="9" x2="9" y2="15" />
          <line x1="9" y1="9" x2="15" y2="15" />
        </svg>
      </div>
      <div>
        <h2 class="modal-title">Obra perdida</h2>
        <p class="modal-subtitle">Preencha os dados sobre a perda</p>
      </div>
    </div>
    <button class="btn-close" type="button" (click)="close.emit()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group">
      <label class="form-label" for="taskDescription">Descreva o relato sobre a perda</label>
      <textarea
        id="taskDescription"
        class="form-textarea"
        [(ngModel)]="taskDescription"
        placeholder="Descreva o relato sobre a perda..."
        rows="3"
      ></textarea>
    </div>

    <div class="form-group">
      <label class="form-label" for="responsavel">
        Responsável
        <span class="required">*</span>
      </label>
      <app-filtro-responsavel
        [responsaveis]="responsavel"
        [value]="responsavelSelecionado"
        (valueChange)="responsavelSelecionado = $event; campoObrigatorioErro = false"
        placeholder="Selecione o responsável"
        placeholderBusca="Buscar responsável"
      ></app-filtro-responsavel>
      <span class="error-msg" *ngIf="campoObrigatorioErro && !responsavelSelecionado">
        Campo obrigatório!
      </span>
    </div>

    <div class="form-group">
      <label class="form-label" for="concorrente">
        Concorrente
        <span class="required">*</span>
      </label>
      <select
        id="concorrente"
        class="form-select"
        [(ngModel)]="concorrenteSelecionado"
        [class.form-input--error]="campoObrigatorioErro && !concorrenteSelecionado"
      >
        <option value="">Selecione o concorrente</option>
        <option *ngFor="let concorrente of Arrconcorrentes" [ngValue]="concorrente.id">
          {{ concorrente.description }}
        </option>
      </select>
      <span class="error-msg" *ngIf="campoObrigatorioErro && !concorrenteSelecionado">
        Campo obrigatório!
      </span>
    </div>

    <div class="form-group">
      <label class="form-label" for="motivo">
        Motivo da perda
        <span class="required">*</span>
      </label>
      <select
        id="motivo"
        class="form-select"
        [(ngModel)]="motivoSelecionado"
        [class.form-input--error]="campoObrigatorioErro && !motivoSelecionado"
      >
        <option value="" selected>Qual o motivo da perda?</option>
        <option *ngFor="let motivo of ArrMotivos" [ngValue]="motivo.id">
          {{ motivo.description }}
        </option>
      </select>
      <span class="error-msg" *ngIf="campoObrigatorioErro && !motivoSelecionado">
        Campo obrigatório!
      </span>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn-secondary" type="button" (click)="clear()">
      Limpar dados
    </button>
    <button
      class="btn-primary"
      type="button"
      (click)="atualizarObraPerdida()"
      [disabled]="carregando"
    >
      Obra perdida
    </button>
  </div>
</div>
